import type { IconName } from '@similarweb/icons';
import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { StyledMetricIcon } from './styles';

export type CompanyInfoItemProps = {
  iconName: IconName;
  className?: string;
};

export const MetricIcon: React.FC<CompanyInfoItemProps> = ({ iconName }) => (
  <StyledMetricIcon data-automation="MetricIcon">
    <SWReactIcons iconName={iconName} size="xs" iconColor={colorsPalettes.bluegrey[500]} />
  </StyledMetricIcon>
);
